import styled from 'styled-components';
import GavelIcon from '@mui/icons-material/Gavel';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuctionDto } from '../../../../services/Auction/auctionService.dto';

const Container = styled.div`
  display: grid;
  grid-template-columns: 100%;
`;

const StyledButton = styled.div`
  cursor: pointer;
  display: flex;
  justify-self: center;
`;

interface Props {
  auction: AuctionDto;
}

const AuctionActions = ({ auction }: Props) => {
  const { t } = useTranslation('items');
  const navigate = useNavigate();

  const goToOnSiteAuction = () => navigate(`/items/onsite/${auction.itemId}`);

  return (
    <Container>
      <StyledButton title={t('auctions.actions.on-site')} onClick={goToOnSiteAuction}>
        <GavelIcon style={{ fontSize: 20 }} />
      </StyledButton>
    </Container>
  );
};

export default AuctionActions;
